import { useState } from "react";
import {
  Grid,
  Paper,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Divider,
} from "@mui/material";

import PageLayout from "components/layout/PageLayout";
import StockByDateList from "components/Home/StockByDateList";
import StockList from "components/Home/StockList";
import StockSummaryList from "components/Home/StockSummaryList";
import { Roles } from "constants/index";
import { useSession } from "providers/SessionProvider";

type StockViewMode = "detalle" | "resumido" | "fecha";

export default function HomePage() {
  const { userData } = useSession();
  const isClientUser = userData?.role === Roles.CLIENT;
  const [viewMode, setViewMode] = useState<StockViewMode>("detalle");
  const effectiveViewMode =
    isClientUser && viewMode === "detalle" ? "resumido" : viewMode;

  return (
    <PageLayout
      pageTitle="Inicio"
      pageDesc="Bienvenido a SHC Logística! Consulte el stock aquí"
    >
      <Paper elevation={3} sx={{ p: 2, mb: 3 }}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Typography variant="h6">Visualización de Stock</Typography>

              <FormControl component="fieldset">
                <RadioGroup
                  row
                  value={effectiveViewMode}
                  onChange={(e) =>
                    setViewMode(e.target.value as StockViewMode)
                  }
                >
                  {!isClientUser && (
                    <FormControlLabel
                      value="detalle"
                      control={<Radio color="primary" />}
                      label="Stock por Detalle"
                    />
                  )}
                  <FormControlLabel
                    value="resumido"
                    control={<Radio color="primary" />}
                    label="Stock Resumido"
                  />
                  <FormControlLabel
                    value="fecha"
                    control={<Radio color="primary" />}
                    label="Stock por Fecha"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
      </Paper>

      <Divider sx={{ mb: 3 }} />

      {effectiveViewMode === "resumido" ? (
        <StockSummaryList />
      ) : effectiveViewMode === "fecha" ? (
        <StockByDateList />
      ) : (
        <StockList />
      )}
    </PageLayout>
  );
}
